import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Service } from "../shared/services/service";
import { Funcoes } from "../funcoes";

@Injectable()
export class ObservacoesLaudosService extends Service {

  protected url: string = this.dominio + "/adm/laudos-cd/observacoes/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-observacoes/observacoes-laudos.service.ts